import styled, { css } from 'styled-components';
import { getStylesBySelected } from './utils/getStylesBySelected.js';
import { themeGet } from '../../foundation/theme/themeGet/get.js';
import { pxToRem } from '../../foundation/spacing/utils.js';
import { interactiveTransition } from '../../foundation/theme/utils.js';

var ButtonStyling = css(["outline:none;padding:", ";min-width:", ";min-height:", ";box-sizing:border-box;background-color:transparent;border:none;border-radius:", ";&:focus-visible{box-shadow:0 0 0 ", " ", ";}&:hover{background-color:", ";}&:disabled{background-color:transparent;}", ";"], themeGet('spacing.sm'), themeGet('spacing.3xl'), themeGet('spacing.3xl'), themeGet('borderRadius.circle'), pxToRem(4), themeGet('colors.focus.primary'), themeGet('colors.brandPrimary.50'), interactiveTransition);
var PaginationPage = styled.button.withConfig({
  displayName: "PaginationPage",
  componentId: "sc-ticcbc-0"
})(["", ";color:", ";&:disabled{color:", ";}", ";"], ButtonStyling, themeGet('colors.text.100'), themeGet('colors.disabled.200'), function (props) {
  return props.$selected && getStylesBySelected();
});
var PaginationArrowButton = styled.button.withConfig({
  displayName: "PaginationArrowButton",
  componentId: "sc-ticcbc-1"
})(["", ";& svg{color:", ";}&:disabled svg{color:", ";}"], ButtonStyling, themeGet('colors.text.300'), themeGet('colors.disabled.200'));
var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-ticcbc-2"
})(["display:flex;flex-direction:row;gap:", ";"], themeGet('spacing.sm'));

export { Container, PaginationArrowButton, PaginationPage };
